import { render, staticRenderFns } from "./ReviewTab.vue?vue&type=template&id=7c52b581&"
import script from "./ReviewTab.vue?vue&type=script&lang=ts&"
export * from "./ReviewTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports